import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import '@/styles/index.scss' // global css
// 视频预览组件
import VideoPreview from "@/components/VideoPreview"
import App from './App'
import router from './router'
import store from './store'
import '@/icons' // icon
import '@/permission' // permission control
import { download } from '@/utils/request'

Vue.use(ElementUI, { locale })
Vue.component('VideoPreview', VideoPreview)
Vue.config.productionTip = false
Vue.prototype.download = download
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js